export default __webpack_public_path__ + "static/media/slot_card_background.424fc8bd.png";